export var Status;
(function (Status) {
    /** Unknown status. */
    Status["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** The campaign is actively collecting donations. */
    Status["COLLECTING"] = "COLLECTING";
    /** The campaign has passed its end date and `acceptDonationsAfterEndDate` is `false`. */
    Status["EXPIRED"] = "EXPIRED";
    /** The campaign has reached its target amount and `acceptDonationsAfterGoal` is `false`. */
    Status["GOAL_REACHED"] = "GOAL_REACHED";
})(Status || (Status = {}));
export var Frequency;
(function (Frequency) {
    /** Unknown frequency. */
    Frequency["UNKNOWN_FREQUENCY"] = "UNKNOWN_FREQUENCY";
    /** One-time donation. */
    Frequency["ONE_TIME"] = "ONE_TIME";
    /** The donation repeats every week. */
    Frequency["WEEK"] = "WEEK";
    /** The donation repeats every month. */
    Frequency["MONTH"] = "MONTH";
    /** The donation repeats every year. */
    Frequency["YEAR"] = "YEAR";
})(Frequency || (Frequency = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map